import { Variant } from '../../types/product';
import getSelectedVariantId from './getSelectedVariantId';
import updateVariantAvailability from './updateVariantAvailability';
import updateVariantInputId from './updateVariantInputId';
import updateVariantUrl from './updateVariantUrl';
import preselectVariantFromUrl from './preselectVariantFromUrl';
import updateAddToCartBtn from './updateAddToCartBtn';
import updateVariantPrice from './updateVariantPrice';

const initProductVariants = (): void => {
  const productForm = document.querySelector<HTMLFormElement>('[data-product-form]');
  if (!productForm) return;
  const atcButtonEl = productForm.querySelector<HTMLButtonElement>('button[type="submit"]');
  const productVariantsEl = productForm.querySelector<HTMLDivElement>('[data-product-variants]');
  const productVariantsDataEl = productVariantsEl?.querySelector<HTMLScriptElement>('[data-product-variants-data]');
  if (!atcButtonEl || !productVariantsEl || !productVariantsDataEl) return;

  const variantsDataText: string = productVariantsDataEl.textContent ?? '';
  if (!variantsDataText) return;
  const variantsData: Variant[] = JSON.parse(variantsDataText);

  preselectVariantFromUrl(variantsData, productVariantsEl, atcButtonEl);
  updateVariantAvailability(variantsData, productVariantsEl);

  productVariantsEl.addEventListener('change', (evt: Event): void => {
    const inputEl = (evt.target as HTMLInputElement).closest<HTMLInputElement>('[data-product-variants-input]');
    if (!inputEl) return;

    const optionsContainer = inputEl.closest<HTMLDivElement>('[data-product-variants]');
    if (!optionsContainer) return;

    const checkedInputs = optionsContainer.querySelectorAll<HTMLInputElement>('[data-product-variants-input]:checked');
    const allCheckedInputs = Array.from(checkedInputs);

    // Create an array with values (selected options)
    const selectedOptions: string[] = allCheckedInputs.map((checkedInput): string => checkedInput.value);

    updateVariantAvailability(variantsData, productVariantsEl);

    const variantId: number | null = getSelectedVariantId(variantsData, selectedOptions);
    if (variantId != null) {
      updateVariantInputId(productVariantsEl, variantId);
      updateVariantUrl(variantId);
      updateVariantPrice(variantsData, variantId);
      updateAddToCartBtn(atcButtonEl);
    }
  });
};

export default initProductVariants;
